class MHeader extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      headers: ["header"],
      logos: [".m-logo"],
      topbar: ".m-topbar",
      headerWrapper: ".m-header__wrapper",
      topbarClose: ".m-topbar__close",
    };
    this.domNodes = queryDomNodes(this.selectors, this);
    this.innerWidth = window.innerWidth;
    this.headerOffsetTop = this.domNodes.headerWrapper.offsetTop;
    this.headerHeight = this.domNodes.headerWrapper.offsetHeight;
    this.stickyHeader = this.dataset.sticky;

    this.classes = {
      scrollUp: "scroll-up",
      scrollDown: "scroll-down",
      stuck: "stuck",
      always: "header-sticky-always",
      headerScrollUp: "header-scroll-up",
      headerScrollDown: "header-scroll-down",
    };

    this._scrollAbortController = null;
    this._ticking = false;
    this._lastScroll = 0;
    this._isStuck = false;

    this.init();
  }

  init() {
    this.transparentHeader =
      this.domNodes?.headers[0]?.dataset.transparent === "true";
    this.initAddon();
    this.handleSticky();
    document.addEventListener("matchMobile", () => this.handleSticky());
    document.addEventListener("unmatchMobile", () => this.handleSticky());
    this.siteNav = new SiteNav(this);
    window.__sfHeader = this;
    window.addEventListener("resize", () => {
      this.innerWidth = window.innerWidth;
      this.headerHeight = this.domNodes.headerWrapper.offsetHeight;
    });
  }

  initAddon() {
    this.megamenu = new Megamenu(this);
    if (Shopify.designMode) {
      MinimogTheme = MinimogTheme || {};
      MinimogTheme?.Wishlist?.updateWishlistCount();
    }
  }

  handleSticky() {
    if (this._scrollAbortController) {
      this._scrollAbortController.abort();
    }
    this._scrollAbortController = new AbortController();
    const { signal } = this._scrollAbortController;

    let extraSpace = 20;
    document.querySelectorAll(".shopify-section-group-header-group").forEach((section) => {
      if (
        !section.classList.contains("m-section-header") &&
        !section.classList.contains("m-section-scaling-logo")
      ) {
        extraSpace += section.offsetHeight;
      }
    });
    const topBar = document.querySelector(".m-topbar");
    if (topBar) extraSpace += topBar.offsetHeight;

    this._extraSpace = extraSpace;
    this._lastScroll = window.scrollY;

    window.addEventListener(
      "scroll",
      () => {
        if (!this._ticking) {
          requestAnimationFrame(() => {
            this._onScroll();
            this._ticking = false;
          });
          this._ticking = true;
        }
      },
      { signal, passive: true }
    );
  }

  _onScroll() {
    const currentScroll = window.scrollY;
    const extraSpace = this._extraSpace;

    // At top — fully reset
    if (currentScroll <= extraSpace) {
      if (this._isStuck) {
        this._isStuck = false;
        this.classList.remove(
          this.classes.scrollUp,
          this.classes.scrollDown,
          this.classes.stuck,
          this.classes.always
        );
        document.body.classList.remove(
          this.classes.headerScrollUp,
          this.classes.headerScrollDown
        );
        // Remove any padding-top added for fixed positioning
        document.body.style.paddingTop = "";
      }
      this._lastScroll = currentScroll;
      return;
    }

    // Apply sticky mode — only once when first crossing threshold
    if (!this._isStuck) {
      this._isStuck = true;
      if (this.stickyHeader === "on_scroll_up") {
        this.classList.add(this.classes.stuck);
        // If header is position:fixed (not sticky), reserve space so content doesn't jump
        if (getComputedStyle(this.domNodes.headerWrapper).position === "fixed") {
          document.body.style.paddingTop = this.headerHeight + "px";
        }
      } else if (this.stickyHeader === "always") {
        this.classList.add(this.classes.always);
      }
    }

    const scrollingDown = currentScroll > this._lastScroll;
    const pastHeader = currentScroll > this.headerHeight + extraSpace;

    if (pastHeader && scrollingDown) {
      // Only toggle if not already in scroll-down state
      if (!this.classList.contains(this.classes.scrollDown)) {
        this.classList.remove(this.classes.scrollUp);
        document.body.classList.remove(this.classes.headerScrollUp);
        this.classList.add(this.classes.scrollDown);
        document.body.classList.add(this.classes.headerScrollDown);
      }
    } else if (!scrollingDown) {
      // Only toggle if not already in scroll-up state
      if (!this.classList.contains(this.classes.scrollUp)) {
        this.classList.remove(this.classes.scrollDown);
        document.body.classList.remove(this.classes.headerScrollDown);
        this.classList.add(this.classes.scrollUp);
        document.body.classList.add(this.classes.headerScrollUp);
      }
    }

    this._lastScroll = currentScroll;
  }
}

customElements.define("m-header", MHeader);